import React from 'react'

const Disclaimer = () => {
  return (
    <div>Disclaimer</div>
  )
}

export default Disclaimer
